import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
// material ui components
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import CircularProgress from '@material-ui/core/CircularProgress';

//icons
import ChevronRight from '@material-ui/icons/ChevronRight';
import SaveIcon from '@material-ui/icons/Save';

//styles
import useStyles from '../forms/styles/wilayah';

// //hooks
import { usePouchDB } from '../../../components/PouchDB/PouchDBProvider';
import { useSnackbar } from 'notistack';

//app components
import { ScrollToTopWithoutRouter } from '../../../components/ScrollToTop';
import { Swipeable } from 'react-swipeable';
import isInt from 'validator/lib/isInt';

// redux implementation
import { withRouter } from "react-router-dom";
import { compose } from "redux";

// axios
import axios from 'axios';
import { Update } from '@material-ui/icons';
import { PdfDocument } from './print';
import { PDFDownloadLink } from "@react-pdf/renderer";
import { convertDay, convertMonth } from '../../../utils/generator'

// const API_URL = 'http://pk2020-portal-bkkbn.apps.tkp.platform.lintasarta.net/api/laporan/injectRekap';
// const API_URL = 'https://portalpk21.bkkbn.go.id/api/laporan/injectRekap';
// const API_URL = 'http://rekap-api-bkkbn.apps.tkp.platform.lintasarta.net/apirekap';
const CryptoJS = require("crypto-js");

function Index({ history }) {
    const USER_KEY_PG = process.env.REACT_APP_USER_KEY_PROXY_GATEWAY
    const db_name = localStorage.getItem("db_name")
    const remote_base = localStorage.getItem("remote_base")
    const url = remote_base + '/' + db_name
    const url_split = remote_base ? remote_base.split('/') : ''
    const couchdb = url_split[url_split.length - 1]

    const classes = useStyles();
    const nextRef = useRef(null)
    const { user: { metadata }, dataKK, dataKB, dataPK, dataBkkbn, dataRekap } = usePouchDB();
    // console.log(metadata, 'metadata')
    const { enqueueSnackbar } = useSnackbar();
    const [insertUpdate, setInsertUpdate] = useState('insert')
    const [error, setError] = useState({})
    const [wilayah, setWilayah] = useState({})
    const [flags, setFlags] = useState(true)
    const [statusForm, setStatusForm] = useState(true)
    const [statusEdit, setStatusEdit] = useState(true)
    const [isSubmitting, setSubmitting] = useState(false);
    const [dataBkkbnDocs, setDataBkkbnDocs] = useState([]);
    const [dataRekapDocs, setDataRekapDocs] = useState([]);
    const [isFetching, setFetching] = useState(true);
    const [dataPrint, setDataPrint] = useState({});

    const [opr, setOpr] = useState(localStorage.getItem("opr"))
    const [localRw, setLocalRw] = useState(localStorage.getItem("rw"))
    const [cekValue, setCekvalue] = useState(false)

    // axios.defaults.headers.post['Content-Type'] ='application/x-www-form-urlencoded';
    const [isSaved, setSaved] = useState({
        local: false,
        remote: false
    })

    // GET ALL DATA REGISTERED
    useEffect(() => {
        let didCancel = false;
        const getAllDataBkkbn = async () => {
            setFetching(true)
            try {

                let selector = {
                    user_name: { $eq: metadata.name },
                }

                if (opr == "true" && localRw != "false") {
                    selector = {
                        user_name: { $eq: metadata.name },
                        id_rw: { $eq: localRw }
                    }
                }
                const query = await dataBkkbn.local.find({
                    selector
                });

                let newDocs = [];
                query.docs.forEach(item => {
                    // if (item.status_sensus == 'Valid' || item.status_sensus == 'Anomali' || item.status_sensus == 'Anomali Terkonfirmasi') {
                    //     newDocs.push(item)
                    // }
                    if (item.status_sensus != "Delete") {
                        if (item.status_draft === '2' && item.status_sensus != '') {
                            newDocs.push(item);
                        }
                    }
                });

                if (!didCancel) {
                    setDataBkkbnDocs(newDocs)
                }
            }
            catch (e) {

            }
            if (!didCancel) {
                setFetching(false);
            }
        }

        getAllDataBkkbn();

        return () => {
            didCancel = true;
        }

    }, [])

    // PERUBAHAN AMBIL YANG RT RW BKKBN
    useEffect(() => {
        if (!wilayah.hasOwnProperty('no_kk')) {
            setWilayah({
                ...wilayah,
                // ['no_kk'] : Date.now().toString()
                // ['no_kk'] : `${metadata.wil_provinsi.id_provinsi}${metadata.wil_kabupaten.id_kabupaten}${metadata.wil_kecamatan.id_kecamatan}${metadata.wil_kelurahan.id_kelurahan}`
            })
        }
    }, []);
    // END PERUBAHAN AMBIL YANG RT RW BKKBN

    const clearForm = () => {
        setWilayah({
            ...wilayah,
            jumlah_kk: '',
            jumlah_kk_didata: '',
            tidak_ditemui: '',
            ditolak: '',
            tidak_jawab: '',
            yang_ada: '',
            belum_didata: ''
        })
    }

    useEffect(() => {

        if (wilayah.id_rw && wilayah.id_rt && flags === true) {
            // console.log(dataBkkbnDocs, 'alldata')
            let dtklg = []
            dataBkkbnDocs.forEach(item => {
                // console.log(item.sts_keluarga, 'sts keluarga')
                if (parseInt(item.id_rt) === parseInt(wilayah.id_rt) && (item.sts_keluarga === '1' || item.sts_keluarga === '6')) {
                    dtklg.push(item)
                }
            })
            const jmlDidata = dtklg.length

            setFlags(false)
            let id_rw_bkkbn = metadata.wil_rw.find(rw => parseInt(rw.id_rw) === parseInt(wilayah.id_rw)).id_rw_bkkbn
            let id_rt_bkkbn = metadata.wil_rw.find(rw => parseInt(rw.id_rw) === parseInt(wilayah.id_rw)).wil_rt.find(rt => parseInt(rt.id_rt) === parseInt(wilayah.id_rt)).id_rt_bkkbn

            let id_rw = metadata.wil_rw.find(rw => parseInt(rw.id_rw) === parseInt(wilayah.id_rw)).id_rw
            let id_rt = metadata.wil_rw.find(rw => parseInt(rw.id_rw) === parseInt(wilayah.id_rw)).wil_rt.find(rt => parseInt(rt.id_rt) === parseInt(wilayah.id_rt)).id_rt

            let targetkk = metadata.wil_rw.find(rw => parseInt(rw.id_rw) === parseInt(wilayah.id_rw)).wil_rt.find(rt => parseInt(rt.id_rt) === parseInt(wilayah.id_rt)).targetkk
            let id = `${metadata.wil_provinsi.id_provinsi_depdagri}${metadata.wil_kabupaten.id_kabupaten_depdagri}${metadata.wil_kecamatan.id_kecamatan_depdagri}${metadata.wil_kelurahan.id_kelurahan_depdagri}${id_rw_bkkbn}${id_rt_bkkbn}`
            id = id.replace(' ', '');
            id_rw_bkkbn = id_rw_bkkbn.replace(' ', '');
            id_rt_bkkbn = id_rt_bkkbn.replace(' ', '');


            console.log("targetkk => ", targetkk)
            console.log("metadata => ", metadata)

            let didCancel = false;

            const getAllDataRekap = async () => {

                setFetching(true)

                try {
                    // console.log("id_rw nya : ", id_rw)


                    const getDataRekap = await dataBkkbn.local.find({
                        selector: {
                            user_name: { $eq: metadata.name },
                            id_rw: { $eq: parseInt(id_rw) },
                            id_rt: { $eq: parseInt(id_rt) },
                            group: { $eq: 'dataRekap' }
                        }
                    });

                    if (!didCancel) {
                        setDataRekapDocs(getDataRekap)
                        setFetching(false);

                        console.log("Get Data Rekap : ", getDataRekap)

                        if (Object.keys(getDataRekap).length > 0 && Object.keys(getDataRekap.docs).length > 0) {
                            console.log("A")
                            setInsertUpdate('Update')
                            setWilayah({
                                ...wilayah,
                                _id: getDataRekap.docs[0]._id,
                                _rev: getDataRekap.docs[0]._rev,
                                jumlah_kk: getDataRekap.docs[0].jumlah_kk ? targetkk : '0',
                                jumlah_kk_didata: jmlDidata > 0 ? jmlDidata : '0'
                            })

                            if (getDataRekap.docs[0].status == 1 || getDataRekap.docs[0].status == 2) {
                                //update
                                // Jumlah Keluarga Yang Belum Didata (formula : Jumlah keluarga yang Ada - (Jumlah Yang Didata+Yg Tdk Dapat Ditemui+Yg Ditolak+Yg Tidak Mampu Menjawab))
                                const x = getDataRekap.docs[0].yang_ada - targetkk - getDataRekap.docs[0].tidak_ditemui - getDataRekap.docs[0].ditolak - getDataRekap.docs[0].tidak_jawab

                                setStatusForm(true);
                                setStatusEdit(false)
                                setWilayah({
                                    ...wilayah,
                                    _id: getDataRekap.docs[0]._id,
                                    _rev: getDataRekap.docs[0]._rev,
                                    jumlah_kk: targetkk > 0 ? targetkk : '0',
                                    jumlah_kk_didata: jmlDidata > 0 ? jmlDidata : '0',
                                    tidak_ditemui: getDataRekap.docs[0].tidak_ditemui ? getDataRekap.docs[0].tidak_ditemui : '0',
                                    ditolak: getDataRekap.docs[0].ditolak ? getDataRekap.docs[0].ditolak : '0',
                                    tidak_jawab: getDataRekap.docs[0].tidak_jawab ? getDataRekap.docs[0].tidak_jawab : '0',
                                    yang_ada: targetkk > 0 ? targetkk : '0',
                                    belum_didata: x ? x : '0',
                                })
                                let message = `Data rekap telah di submit`
                                enqueueSnackbar(message, { variant: "info" })
                            } else if (getDataRekap.docs[0].status == 3) {
                                const x = getDataRekap.docs[0].yang_ada - targetkk - getDataRekap.docs[0].tidak_ditemui - getDataRekap.docs[0].ditolak - getDataRekap.docs[0].tidak_jawab
                                setStatusForm(true);
                                setStatusEdit(true)
                                setWilayah({
                                    ...wilayah,
                                    _id: getDataRekap.docs[0]._id,
                                    _rev: getDataRekap.docs[0]._rev,
                                    jumlah_kk: targetkk > 0 ? targetkk : '0',
                                    jumlah_kk_didata: jmlDidata > 0 ? jmlDidata : '0',
                                    tidak_ditemui: getDataRekap.docs[0].tidak_ditemui ? getDataRekap.docs[0].tidak_ditemui : '0',
                                    ditolak: getDataRekap.docs[0].ditolak ? getDataRekap.docs[0].ditolak : '0',
                                    tidak_jawab: getDataRekap.docs[0].tidak_jawab ? getDataRekap.docs[0].tidak_jawab : '0',
                                    yang_ada: targetkk > 0 ? targetkk : '0',
                                    belum_didata: x ? x : '0',
                                })
                                let message = `Data rekap telah disetujui`
                                enqueueSnackbar(message, { variant: "info" })
                            } else {
                                setStatusForm(false)
                                clearForm()
                                setWilayah({
                                    ...wilayah,
                                    _id: getDataRekap.docs[0]._id,
                                    _rev: getDataRekap.docs[0]._rev,
                                    jumlah_kk: targetkk > 0 ? targetkk : '0',
                                    jumlah_kk_didata: jmlDidata > 0 ? jmlDidata : '0'
                                })
                            }
                        } else if (jmlDidata) {
                            console.log("B")
                            setInsertUpdate('insert');
                            setStatusForm(false);
                            setStatusEdit(true)
                            setWilayah({
                                ...wilayah,
                                _id: Object.keys(getDataRekap.docs).length > 0 ? getDataRekap.docs[0]._id : id,
                                // _rev: getDataRekap.docs[0]._rev ? getDataRekap.docs[0]._rev : '0',
                                jumlah_kk: targetkk > 0 ? targetkk : '0',
                                jumlah_kk_didata: jmlDidata > 0 ? jmlDidata : '0',
                                tidak_ditemui: '0',
                                ditolak: '0',
                                tidak_jawab: '0',
                                yang_ada: targetkk > 0 ? targetkk : '0',
                                belum_didata: '0',
                            })
                        } else {
                            console.log("C")
                            setStatusForm(true)
                            clearForm()
                            let message = `Jumlah keluarga yang didata tidak ditemukan`
                            enqueueSnackbar(message, { variant: "warning" })
                            setWilayah({
                                ...wilayah,
                                _id: '',
                                _rev: '',
                                jumlah_kk: '0',
                                jumlah_kk_didata: '0',
                                yang_ada: targetkk ? targetkk : '0',
                            })
                        }
                    }
                }
                catch (e) {
                    enqueueSnackbar("Gagal memuat data: " + e.message, { variant: "error" })
                }

            }

            getAllDataRekap()
        }
    }, [wilayah])

    //console.log("Data Rekap Doc : ", dataRekapDocs)

    const handleChange = (e) => {
        if (e.target.name === 'id_rt') {
            setFlags(true)
        }

        if (e.target.type === "number") {
            if (parseInt(e.target.value) < 0)
                return false;
        }

        // Jumlah Keluarga Yang Belum Didata (formula : Jumlah keluarga yang Ada - (Jumlah Yang Didata+Yg Tdk Dapat Ditemui+Yg Ditolak+Yg Tidak Mampu Menjawab))

        setWilayah({
            ...wilayah,
            [e.target.name]: e.target.value,
            flags: false
        })

        if (e.target.name == "id_rw") {
            if (e.target.value == "") {
                setWilayah({
                    ...wilayah,
                    ["id_rt"]: "",
                    flags: false
                })
            }
        }

        setError({
            ...error,
            [e.target.name]: ""
        })
    }

    useEffect(() => {
        const a = wilayah.yang_ada ? wilayah.yang_ada : 0
        const b = wilayah.jumlah_kk_didata ? wilayah.jumlah_kk_didata : 0
        const c = wilayah.tidak_ditemui ? wilayah.tidak_ditemui : 0
        const d = wilayah.ditolak ? wilayah.ditolak : 0
        const f = wilayah.tidak_jawab ? wilayah.tidak_jawab : 0
        let blmDidata = a - b - c - d - f

        if (wilayah.flags === false) {
            setWilayah({
                ...wilayah,
                belum_didata: Math.abs(blmDidata).toString(),
                flags: true
            })
        }
        // console.log(wilayah, 'wilayah')
    }, [wilayah]);

    useEffect(() => {

        if (!statusEdit) {

            if (Object.keys(dataRekapDocs).length > 0 && Object.keys(dataRekapDocs.docs).length > 0) {
                const dataRekap = dataRekapDocs.docs[0]
                const belumDidata = parseInt(dataRekap.yang_ada) - (parseInt(dataRekap.jumlah_kk_didata) + parseInt(dataRekap.tidak_ditemui) + parseInt(dataRekap.tidak_jawab) + parseInt(dataRekap.ditolak))
                let submited = dataRekap.tgl_submit
                if (!submited) {
                    const date = new Date();
                    const dayDate = date.getDate();
                    const month = convertMonth(date.getMonth())
                    const year = date.getFullYear();
                    const day = convertDay(date.getDay())
                    submited = day + ", " + dayDate + " " + month + " " + year
                }
                const dataToPrint = {
                    provinsi: metadata.wil_provinsi.nama_provinsi,
                    kabupaten: metadata.wil_kabupaten.nama_kabupaten,
                    kecamatan: metadata.wil_kecamatan.nama_kecamatan,
                    kelurahan: metadata.wil_kelurahan.nama_kelurahan,
                    rw: metadata.wil_rw.find(rw => parseInt(rw.id_rw) === parseInt(dataRekap.id_rw)).nama_rw,
                    rt: metadata.wil_rw.find(rw => parseInt(rw.id_rw) === parseInt(dataRekap.id_rw)).wil_rt.find(rt => parseInt(rt.id_rt) === parseInt(dataRekap.id_rt)).nama_rt,
                    yang_ada: dataRekap.yang_ada,
                    didata: dataRekap.jumlah_kk_didata,
                    tidak_ditemui: dataRekap.tidak_ditemui,
                    ditolak: dataRekap.ditolak,
                    tidak_jawab: dataRekap.tidak_jawab,
                    belum_didata: belumDidata >= 0 ? belumDidata : 0,
                    tgl_submit: submited,
                    pendata: metadata.nama_lengkap,
                    user_name: dataRekap.user_name
                }

                let ciphertext = CryptoJS.AES.encrypt(JSON.stringify(dataToPrint), process.env.REACT_APP_SECRET_KEY_PDF).toString();

                const dataToPdf = {
                    ...dataToPrint,
                    dataQr: ciphertext
                }
                setDataPrint(dataToPdf)

                console.log("data to ori => ", dataToPrint)

                console.log("wilayah => ", wilayah)

                if (wilayah.jumlah_kk_didata != dataRekap.jumlah_kk_didata || wilayah.jumlah_kk != dataRekap.yang_ada) {
                    setCekvalue(true)
                }


            }

        }

    }, [statusEdit, dataRekapDocs])

    const validate = () => {
        let newError = {};
        const math = parseInt(wilayah.jumlah_kk_didata) + parseInt(wilayah.tidak_ditemui) + parseInt(wilayah.ditolak) + parseInt(wilayah.tidak_jawab)
        let total = wilayah.yang_ada - math

        if (!wilayah.id_rw) {
            newError.id_rw = "RW/Dusun wajib diisi";
        }

        if (!wilayah.id_rt) {
            newError.id_rt = "RT wajib diisi";
        }

        if (!wilayah.jumlah_kk) {
            newError.jumlah_kk = "Jumlah KK wajib diisi";
        }

        if (!wilayah.yang_ada) {
            newError.yang_ada = "Jumlah KK yang ada wajib diisi";
        } else {
            if (wilayah.yang_ada < math)
                newError.yang_ada = "Jumlah KK yang ada kurang dari jumlah KK yang didata";
        }

        if (!wilayah.jumlah_kk_didata) {
            newError.jumlah_kk_didata = "Jumlah KK yang didata wajib diisi";
        }

        if (!wilayah.tidak_ditemui) {
            newError.tidak_ditemui = "Jumlah KK yang tidak dapat ditemui wajib diisi";
        } else {
            if (total < 0)
                newError.tidak_ditemui = "Total jumlah KK melebihi jumlah KK yang ada";
        }

        if (!wilayah.ditolak) {
            newError.ditolak = "Jumlah KK yang ditolak wajib diisi";
        } else {
            if (total < 0)
                newError.ditolak = "Total jumlah KK melebihi jumlah KK yang ada";
        }

        if (!wilayah.tidak_jawab) {
            newError.tidak_jawab = "Jumlah KK yang tidak mampu menjawab wajib diisi";
        } else {
            if (total < 0)
                newError.tidak_jawab = "Total jumlah KK melebihi jumlah KK yang ada";
        }

        return newError;

    }

    const handleUbah = async () => {
        if (wilayah._rev) {
            console.log('xxx')
        } else {
            const getDataRekap = await dataBkkbn.local.find({
                selector: {
                    user_name: { $eq: metadata.name },
                    id_rw: { $eq: parseInt(wilayah.id_rw) },
                    id_rt: { $eq: parseInt(wilayah.id_rt) },
                    group: { $eq: 'dataRekap' }
                }
            });
            console.log(wilayah.id_rw, wilayah.id_rt, getDataRekap, 'zzzzzzz')
            let targetkk = metadata.wil_rw.find(rw => parseInt(rw.id_rw) === parseInt(wilayah.id_rw)).wil_rt.find(rt => parseInt(rt.id_rt) === parseInt(wilayah.id_rt)).targetkk
            const x = getDataRekap.docs[0].yang_ada - targetkk - getDataRekap.docs[0].tidak_ditemui - getDataRekap.docs[0].ditolak - getDataRekap.docs[0].tidak_jawab
            setWilayah({
                ...wilayah,
                _id: getDataRekap.docs[0]._id,
                _rev: getDataRekap.docs[0]._rev,
                jumlah_kk: getDataRekap.docs[0].jumlah_kk ? getDataRekap.docs[0].jumlah_kk : '0',
                jumlah_kk_didata: targetkk ? targetkk : '0',
                tidak_ditemui: getDataRekap.docs[0].tidak_ditemui ? getDataRekap.docs[0].tidak_ditemui : '0',
                ditolak: getDataRekap.docs[0].ditolak ? getDataRekap.docs[0].ditolak : '0',
                tidak_jawab: getDataRekap.docs[0].tidak_jawab ? getDataRekap.docs[0].tidak_jawab : '0',
                yang_ada: targetkk ? targetkk : '0',
                belum_didata: x ? x : '0',
            })
        }
        setStatusForm(false);
        setStatusEdit(true);
    }

    const handleSubmit = target => async (e) => {
        e.preventDefault();
        const findErrors = validate();

        const errorValues = Object.values(findErrors);

        if (errorValues.length > 0 && errorValues.some(err => err !== '')) {
            console.log("run validate")
            setError(findErrors);
        } else {
            console.log("validate not run")

            const id_provinsi = metadata.wil_provinsi.id_provinsi_depdagri
            const id_kabupaten = metadata.wil_kabupaten.id_kabupaten_depdagri
            const id_kecamatan = metadata.wil_kecamatan.id_kecamatan_depdagri

            const id_kelurahan_depdagri = metadata.wil_kelurahan.id_kelurahan_depdagri

            let id_rw_bkkbn = metadata.wil_rw.find(rw => parseInt(rw.id_rw) === parseInt(wilayah.id_rw)).id_rw_bkkbn
            let id_rt_bkkbn = metadata.wil_rw.find(rw => parseInt(rw.id_rw) === parseInt(wilayah.id_rw)).wil_rt.find(rt => parseInt(rt.id_rt) === parseInt(wilayah.id_rt)).id_rt_bkkbn

            const id_kelurahan = metadata.wil_kelurahan.id_kelurahan
            let id_rw = metadata.wil_rw.find(rw => parseInt(rw.id_rw) === parseInt(wilayah.id_rw)).id_rw
            let id_rt = metadata.wil_rw.find(rw => parseInt(rw.id_rw) === parseInt(wilayah.id_rw)).wil_rt.find(rt => parseInt(rt.id_rt) === parseInt(wilayah.id_rt)).id_rt

            id_rw_bkkbn = id_rw_bkkbn.replace(' ', '');
            id_rt_bkkbn = id_rt_bkkbn.replace(' ', '');
            let id = `${metadata.wil_provinsi.id_provinsi_depdagri}${metadata.wil_kabupaten.id_kabupaten_depdagri}${metadata.wil_kecamatan.id_kecamatan_depdagri}${metadata.wil_kelurahan.id_kelurahan_depdagri}${id_rw_bkkbn}${id_rt_bkkbn}`

            id = id.replace(' ', '')
            const jumlah_kk = wilayah.jumlah_kk
            const jumlah_kk_didata = wilayah.jumlah_kk_didata
            const tidak_ditemui = wilayah.tidak_ditemui
            const ditolak = wilayah.ditolak
            const tidak_jawab = wilayah.tidak_jawab
            const yang_ada = wilayah.yang_ada

            let http_method = ''

            if (insertUpdate === 'pdate') {
                http_method = 'PUT'
            } else {
                http_method = 'POST'
            }

            const date = new Date();
            const dayDate = date.getDate();
            const month = convertMonth(date.getMonth())
            const year = date.getFullYear();
            const day = convertDay(date.getDay())
            const submited = day + ", " + dayDate + " " + month + " " + year

            console.log("day => ", submited)

            const dataRekapAll = {
                _id: wilayah._id,

                user_name: metadata.name,
                id: id,
                group: 'dataRekap',
                id_kelurahan: parseInt(id_kelurahan),
                id_rt: parseInt(id_rt),
                id_rw: parseInt(id_rw),
                jumlah_kk: parseInt(jumlah_kk),
                jumlah_kk_didata: parseInt(jumlah_kk_didata),
                status: 2,
                ditolak: parseInt(ditolak),
                tidak_ditemui: parseInt(tidak_ditemui),
                tidak_jawab: parseInt(tidak_jawab),
                yang_ada: parseInt(yang_ada),
                http_method: http_method,
                tgl_submit: submited
            }

            const dataRekapFix = {
                ...dataRekapAll
            }

            try {

                let dataToSave = {
                    ...dataRekapFix,
                }

                let dataToLocal = {
                    ...dataRekapFix,
                    _rev: wilayah._rev,
                }
                try {

                    // let kkDocRemote = await dataBkkbn.remote.get(wilayah._id);
                    const data_selector = {
                        "selector": {
                            _id: wilayah._id
                        },
                        "limit": 10000
                    }
                    const idkec= metadata?.wil_kecamatan?.id_kecamatan

                    let kkDocRemote = await axios.post(url + '/_find?couchdb=' + couchdb + '&database-name=' + db_name + "&idKec=" + idkec, data_selector, {
                        // headers: { user_key: USER_KEY_PG }
                        headers: { Authorization: 'Basic YWRtaW46cGFzc3dvcmQ=' }
                    })

                    dataToSave = {
                        ...dataRekapFix,
                        _rev: kkDocRemote._rev
                    }
                } catch (error) {
                    console.log("er => ", error)
                }

                // await dataBkkbn['remote'].put(dataToSave);
                await axios.put(url + '/' + dataToSave._id + '/_put?couchdb=' + couchdb + '&database-name=' + db_name + '&_id=' + dataToSave._id + "&idKec=" + metadata?.wil_kecamatan?.id_kecamatan, dataToSave, {
                    // headers: { user_key: USER_KEY_PG }
                    headers: { Authorization: 'Basic YWRtaW46cGFzc3dvcmQ=' }
                })
                await dataBkkbn['local'].put(dataToLocal);

                let message = (http_method === 'PUT') ? 'Data Rekap berhasil diupdate' : 'Data Rekap berhasil disimpan'
                enqueueSnackbar(message, { variant: "success" })

                setStatusForm(true)
                setStatusEdit(false)

                setError({})
                setTimeout(() => {
                    window.location.reload();
                }, 1000)

            } catch (error) {
                console.log("error => ", error)

                enqueueSnackbar(error.message, { variant: "error" })
            }

        }
    }

    return (
        <div>
            <form onSubmit={handleSubmit} className={classes.form}>
                <ScrollToTopWithoutRouter />
                <Grid container spacing={3}>

                    <Grid item xs={12} className={classes.textCenter}>
                        <Typography variant="h5" component="h1" style={{ marginTop: '5px' }}>Rekap RT</Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Divider />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Typography>Provinsi: {metadata.wil_provinsi.nama_provinsi}</Typography>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Typography>Kabupaten/Kota: {metadata.wil_kabupaten.nama_kabupaten}</Typography>

                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Typography>Kecamatan: {metadata.wil_kecamatan.nama_kecamatan}</Typography>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Typography>Desa/Kel: {metadata.wil_kelurahan.nama_kelurahan}</Typography>
                    </Grid>

                    <Grid item xs={12}>
                        <Divider />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <FormControl
                            disabled={isSubmitting}
                            variant="outlined" fullWidth error={error.id_rw ? true : false}>
                            {opr == "true" && localRw != "false" ?
                                <>
                                    <Select
                                        id="id_rw"
                                        value={wilayah.id_rw || ''}
                                        onChange={handleChange}
                                        name="id_rw"
                                        displayEmpty
                                    >
                                        <MenuItem value="">Pilih RW/Dusun</MenuItem>
                                        {
                                            metadata.wil_rw.map(rw => {
                                                if (parseInt(rw.id_rw) === parseInt(localRw)) {
                                                    return <MenuItem key={rw.id_rw} value={rw.id_rw}>{rw.id_rw_bkkbn} - {rw.nama_rw}</MenuItem>
                                                }
                                            })
                                        }
                                    </Select>
                                </>
                                :
                                <>
                                    <Select
                                        id="id_rw"
                                        value={wilayah.id_rw || ''}
                                        onChange={handleChange}
                                        name="id_rw"
                                        displayEmpty
                                    >
                                        <MenuItem value="">Pilih RW/Dusun</MenuItem>
                                        {metadata.wil_rw.map(rw => <MenuItem key={rw.id_rw} value={rw.id_rw}>{rw.id_rw_bkkbn} - {rw.nama_rw}</MenuItem>)}
                                    </Select>
                                </>
                            }
                            <FormHelperText>{error.id_rw}</FormHelperText>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <FormControl
                            disabled={isSubmitting}
                            variant="outlined" fullWidth error={error.id_rt ? true : false}>

                            <Select
                                id="id_rt"
                                value={wilayah.id_rt || ''}
                                onChange={handleChange}
                                name="id_rt"
                                displayEmpty
                            >
                                <MenuItem value="">Pilih RT</MenuItem>
                                {wilayah.id_rw &&
                                    metadata.wil_rw.find(rw => parseInt(rw.id_rw) === parseInt(wilayah.id_rw)).wil_rt.map(rt => <MenuItem key={rt.id_rt} value={rt.id_rt}>{rt.id_rt_bkkbn} - {rt.nama_rt}</MenuItem>)}


                            </Select>
                            <FormHelperText>{error.id_rt}</FormHelperText>
                        </FormControl>

                    </Grid>

                    <Grid item xs={12} md={2}>
                        Jumlah Keluarga Yang Ada
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <TextField
                            disabled
                            fullWidth
                            variant="outlined"
                            value={wilayah.yang_ada || ''}
                            onChange={handleChange}
                            name="yang_ada"
                            type="number"
                            placeholder="Masukkan Jumlah Keluarga Yang Ada"
                            InputLabelProps={{
                                shrink: true,
                            }}
                            error={error.yang_ada ? true : false}
                            helperText={error.yang_ada}
                        />
                        {/* <FormHelperText>{error.yang_ada}</FormHelperText> */}
                    </Grid>

                    {/* <Grid item xs={12} md={2}>
                        Target KK
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <TextField
                            disabled
                            fullWidth
                            variant="outlined"
                            value={wilayah.jumlah_kk || ''}
                            onChange={handleChange}
                            name="jumlah_kk"
                            type="number"
                            placeholder="Jumlah KK"
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                        <FormHelperText>{error.jumlah_kk}</FormHelperText>
                    </Grid> */}

                    <Grid item xs={12} md={2}>
                        Jumlah Keluarga Yang Didata
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <TextField
                            disabled
                            fullWidth
                            variant="outlined"
                            value={wilayah.jumlah_kk_didata || ''}
                            onChange={handleChange}
                            name="jumlah_kk_didata"
                            type="number"
                            placeholder="Masukkan Jumlah Keluarga Yang Didata"
                            InputLabelProps={{
                                shrink: true,
                            }}
                            error={error.jumlah_kk_didata ? true : false}
                            helperText={error.jumlah_kk_didata}
                        />
                        {/* <FormHelperText>{error.jumlah_kk_didata}</FormHelperText> */}
                    </Grid>

                    <Grid item xs={12} md={2}>
                        Jumlah Keluarga Yang Tidak Dapat Ditemui/Pindah
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <TextField
                            disabled={statusForm}
                            fullWidth
                            variant="outlined"
                            value={wilayah.tidak_ditemui || ''}
                            onChange={handleChange}
                            name="tidak_ditemui"
                            type="number"
                            placeholder="Masukkan Jumlah Keluarga Yang Tidak Dapat Ditemui/Pindah"
                            InputLabelProps={{
                                shrink: true,
                            }}
                            error={error.tidak_ditemui ? true : false}
                            helperText={error.tidak_ditemui}
                        />
                        {/* <FormHelperText>{error.tidak_ditemui}</FormHelperText> */}
                    </Grid>

                    <Grid item xs={12} md={2}>
                        Jumlah Keluarga Yang Menolak Dikunjungi(Ditolak)
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <TextField
                            disabled={statusForm}
                            fullWidth
                            variant="outlined"
                            value={wilayah.ditolak || ''}
                            onChange={handleChange}
                            name="ditolak"
                            type="number"
                            placeholder="Masukkan Jumlah Keluarga Yang Menolak Dikunjungi(Ditolak)"
                            InputLabelProps={{
                                shrink: true,
                            }}
                            error={error.ditolak ? true : false}
                            helperText={error.ditolak}
                        />
                        {/* <FormHelperText>{error.ditolak}</FormHelperText> */}
                    </Grid>

                    <Grid item xs={12} md={2}>
                        Jumlah KK Yang Tidak Mampu Menjawab (Sakit) dan Meninggal
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <TextField
                            disabled={statusForm}
                            fullWidth
                            variant="outlined"
                            value={wilayah.tidak_jawab || ''}
                            onChange={handleChange}
                            name="tidak_jawab"
                            type="number"
                            placeholder="Masukkan Jumlah KK Yang tidak Mampu Menjawab"
                            InputLabelProps={{
                                shrink: true,
                            }}
                            error={error.tidak_jawab ? true : false}
                            helperText={error.tidak_jawab}
                        />
                        {/* <FormHelperText>{error.tidak_jawab}</FormHelperText> */}
                    </Grid>

                    <Grid item xs={12} md={2}>
                        Jumlah Keluarga Belum Didata
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <TextField
                            disabled
                            fullWidth
                            variant="outlined"
                            value={wilayah.belum_didata || ''}
                            onChange={handleChange}
                            name="belum_didata"
                            type="number"
                            placeholder="Masukkan Jumlah Keluarga Belum Didata"
                            InputLabelProps={{
                                shrink: true,
                            }}
                            error={error.belum_didata ? true : false}
                            helperText={error.belum_didata}
                        />
                        {/* <FormHelperText>{error.yang_ada}</FormHelperText> */}
                    </Grid>

                    <Grid item xs={12} md={3} >
                        <Button
                            disabled={statusEdit}
                            onClick={handleUbah}
                            variant="contained" color="primary" style={{ width: '-webkit-fill-available' }}>
                            Ubah
                        </Button>
                    </Grid>
                    <Grid item xs={12} md={3} >
                        {cekValue ?
                            <>
                                <Button
                                    onClick={() => alert("Mohon Perbarui data Rekap RT (klik ubah dan simpan data rekap)")}
                                    variant="contained" color="primary" style={{ width: '-webkit-fill-available' }}>
                                    Download Pdf
                                </Button>
                            </>
                            :
                            <>
                                <Button
                                    disabled={statusEdit}
                                    variant="contained" color="primary" style={{ width: '-webkit-fill-available' }}>
                                    <PDFDownloadLink
                                        document={<PdfDocument data={dataPrint} />}
                                        fileName={metadata.name + "_rekap_rt.pdf"}
                                        style={{ color: statusEdit ? "#9e9e9e" : "#4a4a4a" }}
                                    >
                                        {({ blob, url, loading, error }) =>
                                            loading ? "Loading document..." : "Download Pdf"
                                        }
                                    </PDFDownloadLink>
                                </Button>
                            </>
                        }
                    </Grid>

                    {/* <Grid item xs={12} md={6} >
                        <Button
                            disabled={statusForm}
                            onClick={handleSubmit('local')}
                            variant="contained" color="primary" style={{ width: '-webkit-fill-available' }}>
                            Simpan
                        </Button>
                    </Grid> */}

                </Grid>

            </form>
        </div>
    )
}

export default Index;